import { render } from "./Pagination.vue?vue&type=template&id=1e3b129c"
const script = {}
script.render = render

export default script